import { UserSettings } from 'src/types/UserSettings.ts';
import { PropsWithChildren } from 'react';
import { getProductUrl } from 'src/utils/getProductUrl';

type Props = PropsWithChildren<{
    userSettings: UserSettings;
    code: string;
}>

export const ViewProductLink = ({ userSettings, code, children }: Props) => (
    <a
        href={getProductUrl({
            countryDomain: userSettings.countryDomain,
            currentLocale: userSettings.currentLocale,
            label: code,
        })}
        className="vss-device__product-link"
        target="_blank"
        rel="noreferrer"
    >{children}
    </a>
);
